import React from 'react';
import { useFormContext, FieldError } from 'react-hook-form';
import { useIntl } from 'react-intl';

import TextField from '@mui/material/TextField';

type Props = {
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
};

// react-hook-form-wired MUI TextField with touched-error display. Shared by the
// generic FormField and the open_finance form.
const RhfTextField: React.FC<Props> = ({ name, label, required, disabled, autoFocus }) => {
  const { formatMessage } = useIntl();
  const {
    register,
    formState: { errors, touchedFields },
  } = useFormContext();

  const error = errors[name] as FieldError | undefined;
  const isTouched = !!(touchedFields as Record<string, boolean>)[name];

  return (
    <TextField
      {...register(name)}
      fullWidth
      label={label}
      required={required}
      autoFocus={autoFocus}
      disabled={disabled}
      error={!!error && isTouched}
      helperText={
        isTouched && error?.message
          ? formatMessage({ id: error.message, defaultMessage: error.message })
          : undefined
      }
    />
  );
};

export default RhfTextField;
